import React from "react";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Logo = ({ dark = false }) => (
  <div className="leading-none text-left">
    <div className="font-display text-[22px] font-black tracking-tight md:text-[26px]">
      <span className="text-teal">Jakin</span>
      <span className={dark ? "text-white" : "text-ink"}> CDM</span>
    </div>
    <div className={`mt-1 text-[8.5px] font-bold uppercase tracking-[0.28em] md:text-[9px] ${dark ? "text-zinc-400" : "text-ink/60"}`}>
      Creative Design &amp; Marketing
    </div>
  </div>
);
